import { Row, Col, Table, Spinner } from 'react-bootstrap';
import { useState, useEffect } from 'react';

export default function ServidoresEfetivos() {
    const [cargos, setCargos] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetch("https://dadosabertos.alepe.pe.gov.br/api/v1/cargos/?vinculo=efetivo")
            .then(result => result.json())
            .then(data => {
                setCargos(data);
                setLoading(false);
            });
    }, []);

    return (
        <Row>
            <Col xs="12">
                <p>
                    <small>
                        Você está em <a href="/pessoal">Gestão de Pessoas</a> / Servidores Efetivos
                    </small>
                </p>
            </Col>
            {!loading ? (
                <Col xs="12">
                    <Row>
                        <Col xs={{ span: 2, offset: 10 }} className="mb-2 text-center">
                            <div>
                                <a
                                    href="https://dadosabertos.alepe.pe.gov.br/api/v1/cargos/?vinculo=efetivo&formato=csv"
                                    title="Download em CSV"
                                >
                                    <img src="/img/download-csv.png" height="16" width="16" alt="" />
                                    CSV
                                </a>
                                {/* 
                                <a
                                    href="https://dadosabertos.alepe.pe.gov.br/api/v1/cargos/?vinculo=efetivo&formato=pdf"
                                    style={{ marginLeft: "10px" }}
                                    title="Download em PDF"
                                >
                                    <img src="/img/download-pdf.png" height="16" width="16" alt="" />
                                    PDF
                                </a> 
                                */}
                            </div>
                        </Col>
                    </Row>
                    <div className="table-responsive">
                        <Table striped bordered hover>
                            <thead>
                                <tr>
                                    <th>Cargo</th>
                                    <th>Quantidade</th>
                                </tr>
                            </thead>
                            <tbody>
                                {cargos.map((cargo, index) => (
                                    <tr key={index}>
                                        <td>{cargo.cargo_nivel}</td>
                                        <td>{cargo.total}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </div>
                </Col>
            ) : (
                <Col xs="12" className="text-center">
                    <Spinner />
                </Col>
            )}
        </Row>
    );
}
